import initSentry from "$lib/utilities/sentry";
import { dev } from "$app/environment";
import { handleErrorWithSentry } from "@sentry/sveltekit";

initSentry({
  enabled: !dev || import.meta.env.VITE_SENTRY_DEBUG === "true",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  sampleRate:
    import.meta.env.VITE_SENTRY_SAMPLE_RATE && parseFloat(import.meta.env.VITE_SENTRY_SAMPLE_RATE)
});

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry();
